<template>
    <div class="home">
      <h1>Bem-vindo ao AA. APP</h1>
      <h2>Veja nossos Apps</h2>
      <div class="games-grid">
        <router-link to="/turbotatu" class="game-card">
          <h2>TurboTatu</h2>
          <p>Corrida emocionante com tatus super velozes</p>
        </router-link>
        
        <router-link to="/inventario-facil" class="game-card">
          <h2>Inventário Fácil</h2>
          <p>Sistema de gerenciamento intuitivo</p>
        </router-link>
        
        <router-link to="/dino-dash" class="game-card">
          <h2>Dino Dash</h2>
          <p>Aventura pré-histórica cheia de desafios</p>
        </router-link>


        <router-link to="/doe-facil" class="game-card">
          <h2>Doe Fácil</h2>
          <p>Conectamos pessoas que querem doar itens com aquelas que precisam.</p>
        </router-link>


        <router-link to="/AmazingPhotoEditor" class="game-card">
          <h2>Amazing Photo Editor Pro</h2>
          <p>Edite suas fotos com facilidade, adicione emojis, stickers exclusivos e animados!</p>
        </router-link>


        <router-link to="/MeuQueridometro" class="game-card">
          <h2>Meu Queridometro</h2>
          <p>Sinta-se visto todos os dias! Uma rede social emocional e divertida onde você envia emojis para seus amigos de forma anônima e carinhosa.</p>
        </router-link>


      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'HomePage'
  }
  </script>
  
  <style scoped>
  .home {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
  }
  
  h1 {
    color: #4CAF50;
    text-align: center;
  }
  
  h2 {
    color: #4CAF50;
    text-align: center;
  }
  
  .games-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 20px;
    margin-top: 30px;
  }
  
  .game-card {
    background-color: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    text-decoration: none;
    color: #333;
    transition: transform 0.3s;
  }
  
  .game-card:hover {
    transform: translateY(-5px);
  }
  
  .game-card h2 {
    color: #4CAF50;
    margin-bottom: 10px;
  }
  </style>